import * as React from "react";

import { Period, formatFullRange } from "../../periods";
import { SectionLegend } from "./SectionLegend";
import { READ_ONLY_BOX_CLASS } from "./styles";

export function FocusSummary({ title, period }: { title: string; period: Period }) {
  const range = formatFullRange(period);
  return (
    <fieldset className="tw:m-0 tw:min-w-0 tw:border-0 tw:p-0">
      <SectionLegend swatchClass="tw:bg-(--chart-1)" title={title} />
      <div className={READ_ONLY_BOX_CLASS}>
        <span>
          {period.label}
          {period.label !== range && (
            <span className="tw:ml-2 tw:text-xs tw:text-neutral-500">{range}</span>
          )}
        </span>
      </div>
    </fieldset>
  );
}
